import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Appointment } from 'src/models';
import { api } from 'src/services/api';

export type UseSendAppointmentReminderPayload = {
  appt_uuid: Appointment['appt_uuid'];
  appointment_id: Appointment['appointment_id'];
  sent_by: string;
};

export const useSendAppointmentReminder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['sendAppointmentReminder'],
    mutationFn: ({ appt_uuid, sent_by }: UseSendAppointmentReminderPayload) => {
      return api.post(`/send_appointment_reminders/${appt_uuid}`, {
        sent_by,
      });
    },
    onSuccess: (_, { appointment_id }) => {
      queryClient.invalidateQueries({
        queryKey: ['appointmentNotifications', appointment_id],
      });
    },
  });
};
